/////////////////////////////////////////////////V5CommentStart
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd
//
// whats the deal?
// - back to the fact price/year/miles are of a different class
// - that classFORMRANGESelector has its own event map.. which deals with range rather than generic event used by make/models
// - the clear button is set with a value in state, but the state for price/year/miles is not being set to "" like in make/models to clear that state (thus the clearbutton)
// - need to make sure range missing is not messed up on the URL handling
// - plus range is a compound value, so you have to be mindful that the low or high may be off
//  DDFUX -  manipulation of state could be done a lot smarter
//  DDFIX - Hi/low values should be set somewhere, there is hard codeed year 2023 etc
/////////////////////////////////////////////////V5CommentEnd

import React from 'react'
import {
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
} from 'react-bootstrap'
import queryString from 'query-string'
import { getFilters } from '../../utils/rest'

import Sentinel from '../Sentinel'
import FormRangeSelector from '../FormRangeSelector'
import './InventoryFilter.css'

// DDFix, should this be a utility?
const parseRange = s => {
  try {
    return JSON.parse(s)
  } catch (err) {
    return null
  }
}

export default class InventoryFilter extends React.Component {
  //---------------------------------------
  //
  //---------------------------------------
  constructor(props) {
    console.log(`CFD_FUNC_INVFILTER_constructor:`)

    super(props)

    const {
      models = null,
      bodies = null,
      fuels = null,
      year = null,
      price = null,
      mileage = null,
    } = this.props.search
    this.state = {
      models,
      bodies,
      fuels,
      year: parseRange(year),
      price: parseRange(price),
      mileage: parseRange(mileage),
      make: null,
      model: null,
      bodyTypes: null,
      fuelypes: null,
      makes: null,
      fromPrice: 2000,
    }

    try {
      this.state.make = JSON.parse(models)[0].make.name
      this.state.model = models
    } catch (err) {}

    const now = new Date()

    this.maxYear = now.getFullYear() + (now.getMonth() > 6 ? 1 : 0)
    this.default = {
      price: {
        min: 0,
        max: 500000,
      },
      year: {
        min: 2000,
        max: this.maxYear,
      },
      mileage: {
        min: 0,
        max: 100000,
      },
    }
    this.bodies = []
    this.fuels = []

    // DDFIX damon added this
    this.handleChangePriceRange = this.handleChangePriceRange.bind(this)
  } // end constructor

  //---------------------------------------
  //
  //---------------------------------------
  init = filters => {
    const makes = []
    const models = {}
    const bodyTypes = [...filters.bodyTypes]
    const fuelTypes = [...filters.fuelTypes]
    console.log(`CFD_FUNC_INVFILTER_init:`)
    filters.models.forEach(model => {
      const { make } = model
      if (make.name in models) {
        models[make.name].push(model)
      } else {
        makes.push(make.name)
        models[make.name] = [model]
      }
    })
    this.models = models
    //debugger

    // not sure whow this works
    this.setState({
      makes,
      bodyTypes,
      fuelTypes,
    })
  } //end init filters

  //---------------------------------------
  //
  //---------------------------------------
  componentDidMount() {
    console.log(`CFD_FUNC_INVFILTER_componentDidMount:`)
    getFilters()
      .then(this.init)
      .catch(err => {})
  } // end //

  //---------------------------------------
  //
  //---------------------------------------
  handleSubmit = event => {
    event.preventDefault()
    console.log(`CFD_FUNC_INVFILTER_handleSubmit:`)
    let {
      did,
      models,
      bodies,
      fuels,
      year,
      price,
      mileage,
      ...search
    } = this.props.search
    const mypathname = window.location.pathname.toLowerCase() //returns the current url minus the domain name.

    if (this.state.model) {
      search = {
        ...search,
        models: this.state.model,
      }
    }

    if (this.state.bodies) {
      search.bodies = this.state.bodies
    }
    if (this.state.fuels) {
      search.fuels = this.state.fuels
    }

    if (this.state.year) {
      search.year = JSON.stringify(this.state.year)
    }
    if (this.state.price) {
      search.price = JSON.stringify(this.state.price)
    }
    if (this.state.mileage) {
      search.mileage = JSON.stringify(this.state.mileage)
    }
    // need to reset this on every query
    search.page = 1
    search = '?' + queryString.stringify(search)

    var newpath = ''
    if (mypathname.includes('dealers') && mypathname.includes('inventory'))
      newpath = window.location.pathname
    else newpath = '/inventory'
    this.props.history.push({
      pathname: newpath,
      search,
    })
    //     debugger
    this.props.onChange &&
      this.props.onChange({
        ...this.state,
      })
  } // end handleSubmit

  //---------------------------------------
  //
  //---------------------------------------
  clearFilterButton = props => {
    console.log(`CFD_FUNC_INVFILTER_clearFilterButton:`)
    const clearState = {}
    props.keys.forEach(key => (clearState[key] = null))

    //! returns true if the object is null, undefined or an empty string and false otherwise.
    //If you negate it again you get true for values that exist and false for the ones that do not.
    const show = props.keys.reduce(
      (acc, key) => acc || !!this.state[key],
      false
    )
    return show ? (
      <Button
        title="Clear filter selection"
        bsSize="xsmall"
        onClick={_ =>
          this.setState({
            ...clearState,
            updated: true,
          })
        }
      >
        clear{' '}
      </Button>
    ) : null
  } //end cleanFilterButton

  //---------------------------------------
  //
  //---------------------------------------
  handleChange = event => {
    console.log(
      `CFD_FUNC_INVFILTER_handleChange-DYNAMIC-` +
        event.target.name +
        '-' +
        event.target.value
    )
    const { target } = event
    const { name } = target
    this.setState({
      [name]: target.value,
      updated: true,
    })
  } // end handleChange

  //---------------------------------------
  //
  //---------------------------------------
  handleCancel = event => {
    console.log(`CFD_FUNC_INVFILTER_handleCancel:`)
    event.preventDefault()
    this.props.onCancel && this.props.onCancel()
  }

  //---------------------------------------
  // original one
  //---------------------------------------
  handleChangePriceRange = range => {
    //  are the defaults available somewhere? this is cheezy
    if (!this.state.price) {
      if (range.name == 'fromPrice')
        this.xprice = { min: range.selectedValue, max: 5000000 }
      else this.xprice = { min: 0, max: range.selectedValue }
    } else {
      if (range.name == 'fromPrice')
        this.xprice = { min: range.selectedValue, max: this.state.price.max }
      else this.xprice = { min: this.state.price.min, max: range.selectedValue }
    }

    // ddfix, this is very cheezy. learn to code!
    if (this.xprice.min == 0 && this.xprice.max == 5000000) {
      this.setState({
        price: '',
        updated: true,
      })
    } else {
      this.setState({
        price: this.xprice,
        updated: true,
      })
    }
  }

  //---------------------------------------
  // original one
  //---------------------------------------
  handleChangeMileageRange = range => {
    //  are the defaults available somewhere? this is cheezy
    if (!this.state.mileage) {
      if (range.name == 'fromMileage')
        this.xmileage = { min: range.selectedValue, max: 5000000 }
      else this.xmileage = { min: 0, max: range.selectedValue }
    } else {
      if (range.name == 'fromMileage')
        this.xmileage = {
          min: range.selectedValue,
          max: this.state.mileage.max,
        }
      else
        this.xmileage = {
          min: this.state.mileage.min,
          max: range.selectedValue,
        }
    }

    // ddfix, this is very cheezy. learn to code!
    if (this.xmileage.min == 0 && this.xmileage.max == 5000000) {
      this.setState({
        mileage: '',
        updated: true,
      })
    } else {
      this.setState({
        mileage: this.xmileage,
        updated: true,
      })
    }
  }

  //---------------------------------------
  //
  //---------------------------------------
  handleChangeYearRange = range => {
    // what is this checking
    if (!this.state.year) 
    {
      if (range.name == 'fromYear')
        this.xyear = { min: range.selectedValue, max: 2024 }
      else 
        this.xyear = { min: 0, max: range.selectedValue }
    } 
    else 
    {
      if (range.name == 'fromYear')
        this.xyear = { min: range.selectedValue, max: this.state.year.max }
      else 
        this.xyear = { min: this.state.year.min, max: range.selectedValue }
    
        console.log(`CFD_FUNC_CHANGE THE FILTERAA***********************-` + this.xyear.min + ' ' +  this.xyear.max  );

      }

    // ddfix, this is very cheezy. learn to code!
    if (this.xyear.min == 0 && this.xyear.max == 2024) 
    {
      this.setState({        year: 'All',        updated: true,      })
    } 
    else 
    {
      this.setState({        year: this.xyear,        updated: true,      })
      console.log(`CFD_FUNC_CHANGE THE FILTERbb***********************-` + this.xyear.min + ' ' +  this.xyear.max  );
    }
    console.log(`CFD_FUNC_CHANGE THE FILTERCC***********************-` + this.xyear.min + ' ' +  this.xyear.max  );
  }

 
  //---------------------------------------
  //
  //---------------------------------------
  render = () => {
    const missingModel = this.state.make && !this.state.model

    const makeOptions = this.state.makes &&
      this.state.makes.length && [
        <option value="" key={'_default_'}>
          {this.state.make ? '-- clear filter --' : 'All Makes'}
        </option>,
        ...this.state.makes.map(
          make => (
            <option value={make} key={make.name}>
              {make}
            </option>
          ),
          this
        ),
      ]

    const modelOptions =
      makeOptions && this.state.make && this.models
        ? [
            <option value="" key={'_default_'}>
              {this.state.model
                ? '-- clear filter --'
                : `Select ${this.state.make.match(/^[aeiouy]/i) ? 'an' : 'a'} ${
                    this.state.make
                  } model`}
            </option>,
            ...this.models[this.state.make].map(
              model => (
                <option
                  value={JSON.stringify([model])}
                  key={`${model.make.id}-${model.id}`}
                >
                  {model.name}
                </option>
              ),
              this
            ),
          ]
        : [
            <option value="" key={'_default_'}>
              All Models
            </option>,
          ]

    const bodyTypeOptions = this.state.bodyTypes && [
      <option value="" key={'_default_'}>
        {this.state.bodies ? '-- clear filter --' : 'All Body Types'}
      </option>,
      ...this.state.bodyTypes.map(
        body => (
          <option
            value={JSON.stringify([body])}
            key={`${body.id}-${body.name}`}
          >
            {body.name}
          </option>
        ),
        this
      ),
    ]
    const fuelTypeOptions = this.state.fuelTypes && [
      <option value="" key={'_default_'}>
        {this.state.fuels ? '-- clear filter --' : 'All Fuel Types'}
      </option>,
      ...this.state.fuelTypes.map(
        fuel => (
          <option
            value={JSON.stringify([fuel])}
            key={`${fuel.id}-${fuel.name}`}
          >
            {fuel.name}
          </option>
        ),
        this
      ),
    ]

    const ClearFilterButton = this.clearFilterButton

    return (
      <Form
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        className="InventoryFilterForm"
        id={'InventoryFilterForm-' + (this.props.id || '')}
      >
        <Row>
          {!makeOptions ? (
            <Col md={6} />
          ) : (
            <Col md={6}>
              <Sentinel silent>
                <h3>Make & Model</h3>
                <Col md={12} className="filter-group">
                  <FormGroup
                    controlId="formControlsMake"
                    validationState={
                      this.state.make && this.state.model ? 'success' : null
                    }
                  >
                    <ControlLabel>
                      Make <ClearFilterButton keys={['make', 'model']} />
                    </ControlLabel>
                    <FormControl
                      title="Filter by make/model"
                      value={this.state.make || ''}
                      componentClass="select"
                      name="make"
                      placeholder="Make"
                      onChange={this.handleChange}
                    >
                      {makeOptions}
                    </FormControl>
                    <FormControl.Feedback />
                  </FormGroup>
                  <FormGroup
                    controlId="formControlsModel"
                    validationState={
                      missingModel
                        ? 'warning'
                        : this.state.make && this.state.model ? 'success' : null
                    }
                  >
                    <ControlLabel>Model</ControlLabel>
                    <FormControl
                      title={
                        modelOptions.length <= 1
                          ? 'Please select a Make first'
                          : `Filter ${this.state.make}'s by model`
                      }
                      disabled={modelOptions.length <= 1}
                      value={this.state.model || ''}
                      componentClass="select"
                      name="model"
                      placeholder="Model"
                      onChange={this.handleChange}
                    >
                      {modelOptions}
                    </FormControl>
                    <FormControl.Feedback />
                  </FormGroup>
                </Col>
              </Sentinel>
              <Sentinel silent>
                <Col md={12} className="filter-group">
                  <FormGroup
                    controlId="formControlsBody"
                    validationState={this.state.bodies ? 'success' : null}
                  >
                    <ControlLabel>
                      Body Type <ClearFilterButton keys={['bodies']} />
                    </ControlLabel>
                    <FormControl
                      title="Filter by body type"
                      value={this.state.bodies || ''}
                      componentClass="select"
                      name="bodies"
                      placeholder="Body Type"
                      onChange={this.handleChange}
                    >
                      {bodyTypeOptions}
                    </FormControl>
                    <FormControl.Feedback />
                  </FormGroup>
                </Col>
              </Sentinel>

              <Sentinel silent>
                <Col md={12} className="filter-group">
                  <FormGroup
                    controlId="formControlsFuel"
                    validationState={this.state.fuels ? 'success' : null}
                  >
                    <ControlLabel>
                      Fuel Type <ClearFilterButton keys={['fuels']} />
                    </ControlLabel>
                    <FormControl
                      title="Filter by fuel type"
                      value={this.state.fuels || ''}
                      componentClass="select"
                      name="fuels"
                      placeholder="Fuel Type"
                      onChange={this.handleChange}
                    >
                      {fuelTypeOptions}
                    </FormControl>
                    <FormControl.Feedback />
                  </FormGroup>
                </Col>
              </Sentinel>
            </Col>
          )}

          <Col md={6}>
            <h3>Ranges</h3>
            <Col md={12} className="filter-group">
              <FormGroup
                controlId="formControlsPrice"
                validationState={this.state.price ? 'success' : null}
              >
                <ControlLabel>
                  Price <ClearFilterButton keys={['price']} />
                </ControlLabel>
                <FormRangeSelector
                  id="DataFilter-price-range"
                  label="Price"
                  name="price"
                  unit="dollar"
                  minValue={this.default.price.min}
                  maxValue={this.default.price.max}
                  value={this.state.price}
                  step={10000}
                  onChange={this.handleChangePriceRange}
                />
              </FormGroup>
            </Col>
            <Col md={12} className="filter-group">
              <FormGroup
                controlId="formControlBodyType"
                validationState={this.state.year ? 'success' : null}
              >
                <ControlLabel>
                  Model Year <ClearFilterButton keys={['year']} />
                </ControlLabel>
                <FormRangeSelector
                  id="DataFilter-year-range"
                  label="Model Year"
                  name="year"
                  unit="year"
                  minValue={this.default.year.min}
                  maxValue={this.default.year.max}
                  value={this.state.year}
                  step={1}
                  onChange={this.handleChangeYearRange}
                />
              </FormGroup>
            </Col>
            <Col md={12} className="filter-group">
              <FormGroup
                controlId="formControlMileage"
                validationState={this.state.mileage ? 'success' : null}
              >
                <ControlLabel>
                  Mileage <ClearFilterButton keys={['mileage']} />
                </ControlLabel>
                <FormRangeSelector
                  id="DataFilter-mileage-range"
                  label="Mileage"
                  name="mileage"
                  unit="mile"
                  minValue={this.default.mileage.min}
                  maxValue={this.default.mileage.max}
                  value={this.state.mileage}
                  step={10000}
                  onChange={this.handleChangeMileageRange}
                />
              </FormGroup>
            </Col>
          </Col>
        </Row>
        <FormGroup controlId="formControlsSubmit">
          <Button
            type="submit"
            disabled={!this.state.updated || missingModel}
            title={
              missingModel && this.state.make
                ? `Please select ${
                    this.state.make.match(/^[aeiouy]/i) ? 'an' : 'a'
                  } ${this.state.make} model first`
                : !this.state.updated || missingModel
                  ? 'Please select a filter first'
                  : 'Ready to apply filter'
            }
          >
            Apply Filter
          </Button>
          {this.props.onCancel && <Button type="cancel">Cancel</Button>}
        </FormGroup>
      </Form>
    )
  } // endRender
} //end class



// WEBPACK FOOTER //
// ./src/components/DataView/InventoryFilter.js